class MenuItemData {
  constructor(link, name) {
    this.link = link
    this.name = name
  }
}

export const rulesPath = '/rules/'
export const primarySeoLinks = [
  new MenuItemData('/apa-title-capitalization/', 'APA'),
  new MenuItemData('/mla-title-capitalization/', 'MLA'),
  new MenuItemData('/chicago-title-capitalization/', 'Chicago'),
  new MenuItemData('/sentence-case-converter/', 'Sentence Case'),
]

export const menu = [
  new MenuItemData('/', 'Home'),
  ...primarySeoLinks,
  new MenuItemData(rulesPath, 'Rules'),
  new MenuItemData('/about/', 'About'),
  new MenuItemData('/privacy/', 'Privacy'),
]
